import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-breadcrumb-header',
    templateUrl: './breadcrumb-header.component.html',
    styleUrls: ['./breadcrumb-header.component.scss'],
    standalone: false
})
export class BreadcrumbHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
